import React from 'react';
export function PrivacyPolicy() {
  return <div className="space-y-4 text-sm text-slate-600" data-id="element-89">
      <p data-id="element-90">Last updated: December 2024</p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-91">
        1. Introduction
      </h4>
      <p data-id="element-92">
        Welcome to Santa's Certified Letter. We respect your privacy and are
        committed to protecting your personal data. This privacy policy will
        inform you as to how we look after your personal data when you visit our
        website and tell you about your privacy rights and how the law protects
        you.
      </p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-93">
        2. Data We Collect
      </h4>
      <p data-id="element-94">
        We may collect, use, store and transfer different kinds of personal data
        about you which we have grouped together follows:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-95">
        <li data-id="element-96">
          Identity Data: includes first name, last name, and child's name for
          personalization.
        </li>
        <li data-id="element-97">
          Contact Data: includes email address, delivery address, and telephone
          number.
        </li>
        <li data-id="element-98">
          Transaction Data: includes details about payments and other details of
          products you have purchased from us.
        </li>
      </ul>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-99">
        3. How We Use Your Data
      </h4>
      <p data-id="element-100">
        We will only use your personal data when the law allows us to. Most
        commonly, we will use your personal data in the following circumstances:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-101">
        <li data-id="element-102">To process and deliver your order.</li>
        <li data-id="element-103">To manage our relationship with you.</li>
        <li data-id="element-104">
          To improve our website, products/services, marketing and customer
          relationships.
        </li>
      </ul>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-105">
        4. Data Security
      </h4>
      <p data-id="element-106">
        We have put in place appropriate security measures to prevent your
        personal data from being accidentally lost, used or accessed in an
        unauthorized way, altered or disclosed.
      </p>
    </div>;
}